import { Component, ElementRef, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { AuthService, LocalizeService } from "../../insa-services";
import { appConfig } from "../../../insaweb.config";

@Component({
  templateUrl: "login.component.html",
})
export class LoginComponent {
  username: string;
  password: string;
  submitted: boolean;
  loginText: string = appConfig.loginText;
  passwordChangeVisible: boolean =
    appConfig.showPasswordChangeButtonOnLogin === undefined
      ? true
      : appConfig.showPasswordChangeButtonOnLogin;
  // New: independent visibility flag for "Forgot Password", following the
  // same appConfig-driven pattern as the other buttons on this screen.
  forgotPasswordVisible: boolean =
    (appConfig as any).showForgotPasswordButtonOnLogin === undefined
      ? true
      : (appConfig as any).showForgotPasswordButtonOnLogin;
  languageChangeVisible: boolean =
    appConfig.showLanguageChangeButtonOnLogin === undefined
      ? true
      : appConfig.showLanguageChangeButtonOnLogin;
  registerVisible: boolean =
    appConfig.showRegisterButtonOnLogin === undefined
      ? false
      : appConfig.showRegisterButtonOnLogin;
  //custom client title for online portal
  clientTitle: string =
    appConfig.ClientTitle === undefined
      ? "Online Portal"
      : appConfig.ClientTitle;
  loginTitle: string =
    (appConfig as any).loginTitle ?? this.clientTitle + " Login";
  loginButtonLabel: string = (appConfig as any).loginButtonLabel ?? "Login";
  userIdLabel: string = (appConfig as any).loginLabels?.userId ?? "User ID";
  passcodeLabel: string =
    (appConfig as any).loginLabels?.passcode ?? "Passcode";
  languages: Array<any> = [];
  private jwt = "NO_TOKEN";
  private isRegistrationEnabled = true;
  twoFactorSetupVisible: boolean = true;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _localize: LocalizeService,
    private _element: ElementRef,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    // Clear any lingering pre-2FA state so forward-navigation back to
    // /twoFactorValidate or /twoFactorSetup is blocked after landing here.
    this._authService.clearPreTwoFactorState();

    let routeSnapshot = this.route.snapshot;
    //embedded login - use 'accessToken' to gain permissions
    if (routeSnapshot.queryParamMap.has("accessToken")) {
      this.jwt = routeSnapshot.queryParamMap.get("accessToken");
      if (!this._authService.embeddedLogin(this.jwt)) {
        // this._router.navigateByUrl('/login'); // error occured
      }
    }
    //external login - OpenID example token, looks for 'jwt' query param and uses that to authenticate
    else if (routeSnapshot.queryParamMap.has("Jwt")) {
      this.jwt = routeSnapshot.queryParamMap.get("Jwt");
      this._authService.login("", "", this.jwt);
      this.submitted = true;
      kendo.ui.progress($(".main-loading"), true);
    }
  }

  passwordChange() {
    this._router.navigate(["/changePassword"]);
  }

  // New: entry point into the forgot-password flow, kept fully separate
  // from passwordChange() above (which still requires knowing the current
  // password).
  forgotPassword() {
    this._router.navigate(["/forgotPassword"]);
  }

  register() {
    this._router.navigate(["/register"]);
  }

  onSubmit(form: any): void {
    this._authService.login(form["username"], form["password"]);
    this.submitted = true;
    kendo.ui.progress($(".main-loading"), true);
  }

  ngAfterViewInit() {
    const loadLanguages = () => {
      this.languages = this._localize.getAvailableLocalesWithFriendlyNames();
    };
    loadLanguages();
    this._localize.LocaleChangedEmmiter.subscribe(() => loadLanguages());
    this._localize.applyTranslations(this._element.nativeElement, "LOOKUP");
  }

  selectLanguage(lang) {
    this._localize.setLocale(lang).then(() => {
      this.languages = this._localize.getAvailableLocalesWithFriendlyNames();
      this._localize.applyTranslations(this._element.nativeElement, "LOOKUP");
    });
  }

  twoFactorSetup() {
    this._router.navigate(["/twoFactorSetup"]);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/login.component.ts